export default "__VITE_ASSET__COxxfejk__"